// extracted by mini-css-extract-plugin
export var readonly = "_j5-1";
export var star = "_j5-0";